module.exports = __webpack_public_path__ + "static/vista-1-fc32eaf3c204b93f642639275513c90c.png";